import React from "react";
import RegisterForm from "./RegisterForm";
import registerImg from "../../../assets/images/register.png";
function RegisterLayout() {
  return (
    <div className="container my-4">
      <div className="row">
        <div className="col-lg-6">
          <div className="d-none d-lg-block">
            <img
              className="w-100 h_550x AuthlandingImg object-fit-cover br_25"
              src={registerImg}
              alt=""
            />
          </div>
        </div>
        <div className="col-lg-6 mt-3 mt-lg-0">
          <RegisterForm />
        </div>
      </div>
    </div>
  );
}

export default RegisterLayout;
